import { appRouters, otherRouters, } from '../../router/router'
import Util from '../../lib/util';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import Vuex from 'vuex';
import ajax from '../../lib/ajax'
import appconst from '../../lib/appconst'
import axios from 'axios'
Vue.use(Vuex);
interface AppState {
	cachePage: Array<any>;
	lang: string;
	isFullScreen: boolean;
	openedSubmenuArr: Array<any>;
	menuTheme: string;
	themeColor: string,
	pageOpenedList: Array<any>;
	currentPageName: string;
	currentPath: Array<any>;
	menuList: Array<any>;
	routers: Array<any>;
	tagsList: Array<any>;
	messageCount: number;
	dontCache: Array<any>;
	noticeList: Array<any>;
	totalCount: number,
	currentPage: number,
	pageSize: number,
	waitDoList: Array<any>,
	loading: boolean,
}
class AppModule implements Module<AppState, any>{
	namespaced = true;
	state = {
		cachePage: [],
		lang: '',
		isFullScreen: false,
		openedSubmenuArr: [],
		menuTheme: 'dark',
		themeColor: '',
		pageOpenedList: [{
			meta: { title: 'HomePage' },
			path: '',
			name: 'home'
		}],
		currentPageName: '',
		currentPath: [
			{
				meta: { title: 'HomePage' },
				path: '',
				name: 'home'
			}
		],
		menuList: [],
		routers: [
			otherRouters,
			...appRouters
		],
		tagsList: [...otherRouters.children],
		messageCount: 0,
		dontCache: [],
		noticeList: [{ read: false, type: 0, title: 'First notice', description: 'One day ago' }, { read: false, type: 1 }, { read: false, type: 0, title: 'Second notice', description: 'One month ago' }],

		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		waitDoList: new Array<Object>(),
		loading: false,

	};
	mutations = {
		logout(state: AppState) {
			localStorage.clear();
			sessionStorage.clear();
		},
		setTagsList(state: AppState, list: Array<any>) {
			state.tagsList.push(...list);
		},
		updateMenulist(state: AppState) {
			let menuList: Array<Router> = [];
			appRouters.forEach((item, index) => {
				if (item.permission !== undefined) {
					let hasPermissionMenuArr: Array<Router> = [];
					hasPermissionMenuArr = item.children.filter(child => {
						if (child.permission !== undefined) {
							if (Util.abp.auth.hasPermission(child.permission)) {
								return child;
							}
						} else {
							return child;
						}
					});
					if (hasPermissionMenuArr.length > 0) {
						item.children = hasPermissionMenuArr;
						menuList.push(item);
					}
				} else {
					if (item.children.length === 1) {
						menuList.push(item);
					} else {
						let len = menuList.push(item);
						let childrenArr = [];
						childrenArr = item.children.filter(child => {
							return child;
						});
						let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]));
						handledItem.children = childrenArr;
						menuList.splice(len - 1, 1, handledItem);
					}
				}
			});
			state.menuList = menuList;
		},
		changeMenuTheme(state: AppState, theme: string) {
			state.menuTheme = theme;
		},
		changeMainTheme(state: AppState, mainTheme: string) {
			state.themeColor = mainTheme;
		},
		addOpenSubmenu(state: AppState, name: any) {
			let hasThisName = false;
			let isEmpty = false;
			if (name.length === 0) {
				isEmpty = true;
			}
			if (state.openedSubmenuArr.indexOf(name) > -1) {
				hasThisName = true;
			}
			if (!hasThisName && !isEmpty) {
				state.openedSubmenuArr.push(name);
			}
		},
		closePage(state: AppState, name: any) {
			state.cachePage.forEach((item, index) => {
				if (item === name) {
					state.cachePage.splice(index, 1);
				}
			});
		},
		initCachepage(state: AppState) {
			if (localStorage.cachePage) {
				state.cachePage = JSON.parse(localStorage.cachePage);
			}
		},
		removeTag(state: AppState, name: string) {
			state.pageOpenedList.map((item, index) => {
				if (item.name === name) {
					state.pageOpenedList.splice(index, 1);
				}
			});
		},
		pageOpenedList(state: AppState, get: any) {
			let openedPage = state.pageOpenedList[get.index];
			if (get.argu) {
				openedPage.argu = get.argu;
			}
			if (get.query) {
				openedPage.query = get.query;
			}
			state.pageOpenedList.splice(get.index, 1, openedPage);
			localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
		},
		clearAllTags(state: AppState) {
			state.pageOpenedList.splice(1);
			state.cachePage.length = 0;
			localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
		},
		clearOtherTags(state: AppState, vm: Vue) {
			let currentName = vm.$route.name;
			let currentIndex = 0;
			state.pageOpenedList.forEach((item, index) => {
				if (item.name === currentName) {
					currentIndex = index;
				}
			});
			if (currentIndex === 0) {
				state.pageOpenedList.splice(1);
			} else {
				state.pageOpenedList.splice(currentIndex + 1);
				state.pageOpenedList.splice(1, currentIndex - 1);
			}
			let newCachepage = state.cachePage.filter(item => {
				return item === currentName;
			});
			state.cachePage = newCachepage;
			localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
		},
		setOpenedList(state: AppState) {
			state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouters.children[0]];
		},
		setCurrentPath(state: AppState, pathArr: Array<any>) {
			state.currentPath = pathArr;
		},
		setCurrentPageName(state: AppState, name: string) {
			state.currentPageName = name;
		},
		clearOpenedSubmenu(state: AppState) {
			state.openedSubmenuArr.length = 0;
		},
		increateTag(state: AppState, tagObj: any) {
			if (!Util.oneOf(tagObj.name, state.dontCache)) {
				state.cachePage.push(tagObj.name);
				localStorage.cachePage = JSON.stringify(state.cachePage);
			}
			state.pageOpenedList.push(tagObj);
		}

	}
	actions = {
		async login(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.post("/api/TokenAuth/Authenticate", payload.data);
			var tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined;
			Util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
			//Util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, Util.abp.appPath);

			let time = new Date().getTime().toString();
			localStorage.setItem('authTime', time);
		},
		async externalAuthenticate(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.post("/api/TokenAuth/ExternalAuthenticate", payload.data);
			var tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined;
			Util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
			//Util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, Util.abp.appPath)
			let time = new Date().getTime().toString();
			// debugger;
			localStorage.setItem('authTime', time);
			return rep.data.result;
		},
		async uploadFile(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post("/api/services/app/Common/UploadFile", payload.data);
			return reponse.data.result;
		},
		async uploadImage(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post("/api/services/app/Common/UploadImage", payload.data);
			return reponse.data.result;
		},
		async getAuthorizeUrl(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('api/services/app/IDS/GetAuthorizeUrl', { params: payload.data });
			return reponse.data.result;
		},
		async getWaitDoMsgByUserId(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/Apply/GetWaitDoMsgByUserId', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
			// let page=reponse.data.result as Array<any>;
			// //content.state.totalCount=page.totalCount;
			// content.state.waitDoList=page;
		},
		async getNewsList(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/News/GetAll', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getWaitDoNewsByUserID(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/News/GetWaitDoNewsByUserID', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getWaitNewsApplication(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/News/GetWaitNewsApplication', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getApplicationByUserId(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/IDS/GetApplicationByUserId', { params: payload.data });
			content.state.loading = false;
			return reponse;
		},
		async getApplicationList(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/Apply/GetApplication', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getNewsById(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/News/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async getNewsReadCount(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/News/GetNewsReadCount?Id=' + payload.id);
			return reponse.data.result;
		},
		async getLoginUser(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/User/GetLoginUser');
			return reponse.data.result;
		},
		async getIDSToken(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/IDS/GetIDSToken');
			return reponse.data.result;
		},
		async getUser(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/User/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async createComment(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/NewsComment/Create', payload.data);
			return reponse.data.result;
		},
		async getNewsCommentList(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('/api/services/app/NewsComment/GetAll', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getNewsOperationInfo(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/News/GetNewsOperationInfo', { params: payload.data });
			return reponse.data.result;
		},
		async writeNewsOperation(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/News/WriteNewsOperation', payload.data);
			return reponse.data.result;
		},
		async cancelNewsOperation(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/News/CancelNewsOperation?Id=' + payload.data.id);
			return reponse.data.result;
		},
		async writeNewsReadLog(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/News/WriteNewsReadLog?Id=' + payload.data.id);
			return true;
		},

		async getWeixinJSSDKConfig(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/WeixinServiceAccount/GetJSSDKConfig', { params: payload.data });
			return reponse.data.result;
		},
		async refreshOSSPresignedUri(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/AliyunServiceAccount/ProcessOSSImage', payload.data);
			return reponse.data.result;
		},
		async getNewsGroupById(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/NewsGroup/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async updateCommentApproved(context: ActionContext<AppState, any>, payload: any) {
			await ajax.put('/api/services/app/NewsComment/UpdateCommentApproved?Id=' + payload.id);
			return true;
		},
		async commentDelete(context: ActionContext<AppState, any>, payload: any) {
			await ajax.post('/api/services/app/NewsComment/CommentDelete?Id=' + payload.id);
			return true;
		},
		async getUserStatistics(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/Statistics/GetUserStatistics', { params: payload.data });
			return reponse.data.result;
		},
		async getAppStatistics(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/Statistics/GetAppStatistics', { params: payload.data });
			return reponse.data.result;
		},
		async getNewsStatistics(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/Statistics/GetNewsStatistics', { params: payload.data });
			return reponse.data.result;
		},
		async sendPhoneCode(content: ActionContext<AppState, any>, payload: any) {
			var lang = "zh";
			if (payload.data.lang != null && payload.data.lang != undefined && payload.data.lang == 'en') {
				lang = "en";
			}
			let reponse = await ajax.post('/api/services/app/IDS/SendPhoneCode?username=' + payload.data.username + '&lang=' + lang, payload.data);
			return reponse;
		},
		async confirmPhoneCode(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/IDS/ConfirmPhoneCode?username=' + payload.data.username + "&code=" + payload.data.code, payload.data);
			return reponse;
		},
		async confirmEmailCode(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/IDS/ConfirmEmailCode?email=' + payload.data.username + "&code=" + payload.data.code, payload.data);
			return reponse;
		},
		async updatePassword(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.put('/api/services/app/IDS/UpdatePassword', payload.data);
			return reponse;
		},
		async checkPassword(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/IDS/CheckPassword', payload.data);
			return reponse;
		},
		async sendEmailCode(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/IDS/SendEmailCode?email=' + payload.data.username, payload.data);
			return reponse;
		},
		async getAppByCode(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get("/api/services/app/Apply/GetByCode", { params: payload.data });
			return reponse;
		},
		async getMustReadById(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/MustRead/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async writeMustReadLog(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/MustRead/WriteMustReadLog?Id=' + payload.data.id);
			return true;
		},
		async getXueXiById(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/XueXiNewsService/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async createQuestionByApp(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/QuestionTpl/CreateQuestionByApp', payload.data);
			return reponse.data.result;
		},
		async getQuestionTplById(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/QuestionTpl/Get?Id=' + payload.id);
			return reponse.data.result;
		},
		async createQuestionUser(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/QuestionTpl/CreateQuestionUser', payload.data);
			return reponse.data.result;
		},
		async getQuestionByUserId(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/QuestionTpl/GetQuestionByUserId?Id=' + payload.id);
			return reponse.data.result;
		},

		async changeCulture(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/Configuration/ChangeCulture', payload.data);
			return reponse.data.result;
		},
		async getAll(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/AbpUserConfiguration/GetAll');
			return reponse.data.result;
		},
		async getAIListAll(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('/api/services/app/AIApply/GetAll', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getSessionHistoryList(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('api/services/app/Documents/GetSessionHistoryList', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async setSessionLike(context: ActionContext<AppState, any>, payload: any) {
			await ajax.post('/api/services/app/Documents/SetSessionLike', payload.data);
			return true;
		},
		async setSessionStomp(context: ActionContext<AppState, any>, payload: any) {
			await ajax.post('/api/services/app/Documents/SetSessionStomp', payload.data);
			return true;
		},
		async speechProcess(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post("/api/services/app/AliSpeech/SpeechProcess", payload.data);
			return reponse.data.result;
		},
		async meetingCreate(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/AIMetting/Create', payload.data);
			return reponse.data.result;
		},
		async getSessionHistoryNewByUser(content: ActionContext<AppState, any>, payload: any) {	
			var id= payload && payload.id? payload.id:0;
			let reponse = await ajax.get('api/services/app/Documents/getSessionHistoryNewByUser?Id=' + id);			
			return reponse.data.result;
		},
		async getLocalizations(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/Common/GetLocalizations?language='+ payload.data);
			return reponse.data.result;
		},
		async getUserInfo(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.get("/api/services/app/IDS/GetUserInfo?code="+payload.data);			
			return rep.data.result;
		},
		async getUserByUserName(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.get("/api/services/app/User/GetUserByUserName?userName="+payload.data);			
			return rep.data.result;
		},
		async createAnswer(content: ActionContext<AppState, any>, payload: any) {
			let reponse=await ajax.post('/api/services/app/Answer/create',payload.data);
			return reponse.data;		
		 },	
		async getMustReadClassify(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.get("/api/services/app/MustReadClassify/GetAll", { params: payload.data });			
			return rep.data.result;
		}, 
		async getClassifyNoReadCount(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.get("/api/services/app/MustRead/GetClassifyNoReadCount");			
			return rep.data.result;
		}, 
		async getMustRead(content: ActionContext<AppState, any>, payload: any) {
			let rep = await ajax.get("/api/services/app/MustRead/GetAll", { params: payload.data });			
			return rep.data.result;
		},
		async getISCList(content: ActionContext<AppState, any>, payload: any) {
			content.state.loading = true;
			let reponse = await ajax.get('/api/services/app/Answer/GetISCList', { params: payload.data });
			content.state.loading = false;
			return reponse.data.result;
		},
		async getISCById(content: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.get('/api/services/app/Answer/GetISCDetail?IncidentNumber=' + payload.id);
			return reponse.data.result;
		},
		async setUserApplicationsSortWeb(context: ActionContext<AppState, any>, payload: any) {
			let reponse = await ajax.post('/api/services/app/Apply/SetUserApplicationsSortWeb', payload.data);
			return reponse.data.result;
		},
	}
}
const appModule = new AppModule();
export default appModule;
